import { factoryService, getJsonRequest, postJsonRequest } from '@chilecompra/react-kit/requests'
import { normalizeDniSlashes } from '../modules/utils/normalizeForeignDni'
import { REACT_APP_API_BASE_URL } from '../config/settings/environment'

/**
 * Gets the user info.
 */
export const postGetUserInfo = factoryService(({ dni }) => {
  const body = {
    origen: 'ficha-proveedor-front',
    rut: normalizeDniSlashes(dni),
    validarFallecido: true
  }

  return postJsonRequest(`${REACT_APP_API_BASE_URL}/v1/registro-civil/informacionPersona`, { body })
})

/**
 * Gets the economic activities.
 */
export const getEconomicActivities = factoryService(({ dni }) => {
  return getJsonRequest(`${REACT_APP_API_BASE_URL}/v1/sii/actividad-economica/${normalizeDniSlashes(dni)}`)
})
